var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 456,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 438.859V16.843L11.511 65.93 8.566 94.888l3.808 53.098-3.808 52.095-3.59 96.302 7.398 58.497-7.399 41.132L0 438.859Z",
    fill: "#fff"
  })));
};

export default SvgRight;